import { $t } from "helpers/translator"

const ManageServiceCalls = {
    steps: [
        {
            target: '#serviceCallsTableHeader',
            title: $t('global.tours.ManageServiceCalls.0.title'),
            content: $t('global.tours.ManageServiceCalls.0.content'),
        },
        {
            target: '#serviceErrorsTableHeader',
            title: $t('global.tours.ManageServiceCalls.1.title'),
            content: $t('global.tours.ManageServiceCalls.1.content'),
        },
        {
            target: '#serviceErrorsGraphTitle',
            title: $t('global.tours.ManageServiceCalls.2.title'),
            content: $t('global.tours.ManageServiceCalls.2.content'),
            locale: {
                last: $t('global.tours.ManageServiceCalls.2.confirm')
            }
        }
    ],
    url: '/service'
}

export default ManageServiceCalls